module.exports = __webpack_public_path__ + "img/webcam_on_button.44fff879.svg";